import { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { MplusInfoScoring } from 'widgets/mplus/mplus-info-scoring'

import { mplusStore } from 'entities/mplus/module/mplus-store.ts'

import { CreditInfo } from 'shared/api/mplus/credit-info'
import MPlusSlogan from 'shared/images/m_plus_banner.webp'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { ImageLazy } from 'shared/ui/image-lazy'
import { Loader } from 'shared/ui/loader'
import { LoaderTypes } from 'shared/ui/loader/model.ts'

import s from './styles.module.scss'

interface Props {
  loaderType: LoaderTypes
  isLoader: boolean
  totalPrice: number
  quantity: number
  onSubmit: () => void
}

export const MPlusConnect = observer(
  ({ loaderType, isLoader, onSubmit, totalPrice, quantity }: Props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const [isLoading, setIsLoading] = useState(false)

    const fetchInstallmentInfo = async () => {
      mplusStore.setInstallmentInfo(null)
      try {
        setIsLoading(true)

        const { data: response } = await CreditInfo.getCalculatedInfo({
          price: totalPrice,
          quantity: quantity,
        })
        mplusStore.setInstallmentInfo(response.data)
      } catch {
        navigate(-1)
      } finally {
        setIsLoading(false)
      }
    }

    useEffect(() => {
      void fetchInstallmentInfo()
    }, [])

    return (
      <>
        {isLoader || isLoading ? (
          <Loader
            marginTop={150}
            type={loaderType}
          />
        ) : (
          <>
            <HeaderGoBack
              title={t('mplus.take_mplus')}
              buttonWhite
            />

            <div className={s.mplusBanner}>
              <ImageLazy
                alt="mplus"
                src={MPlusSlogan}
                className={s.image}
              />
              <p className={clsx(s.title, 'semi-bold-20')}>
                {t('mplus.mplus_banner_title')}
              </p>
            </div>

            <MplusInfoScoring />

            <ButtonContinue onClick={onSubmit}>
              <span className={clsx(s.button, 'semi-bold-17')}>
                {t('mplus.open_mplus')}
              </span>
            </ButtonContinue>
          </>
        )}
      </>
    )
  },
)
